var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-loading-bar",class:{ 'is-active': _vm.isLoading }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-loading-bar__track"},[_c('div',{staticClass:"global-loading-bar__fill"})])
}]

export { render, staticRenderFns }